import * as actionTypes from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
const Url = process.env.REACT_APP_MAIN_URL;
export const addContact = (data, resetForm) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_LOADING,
    payload: true,
  });
  axios
    .post(`${Url}contact`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      dispatch({
        type: actionTypes.ADD_Contact,
      });
      dispatch({
        type: actionTypes.SET_LOADING,
        payload: false,
      });
      resetForm();
      toast.success(response.data.status);
    })
    .catch((error) => {
      toast.error(error.response.data.status);
      dispatch({
        type: actionTypes.SET_LOADING,
        payload: false,
      });
    });
};

